import { render } from "./IndexCouponList.vue?vue&type=template&id=14c07c4e&scoped=true"
import script from "./IndexCouponList.vue?vue&type=script&lang=js"
export * from "./IndexCouponList.vue?vue&type=script&lang=js"

import "./IndexCouponList.vue?vue&type=style&index=0&id=14c07c4e&lang=scss&scoped=true"

import exportComponent from "/Users/user/workspace/okshop-diner/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14c07c4e"]])

export default __exports__